const MAC_USERNAME_PATTERN = /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/;

export interface SubscriberIdentityFields {
  username?: string | null;
  portalUsername?: string | null;
  displayUsername?: string | null;
  networkUsername?: string | null;
}

export function isMacStyleUsername(value: string | null | undefined): boolean {
  if (!value) return false;
  return MAC_USERNAME_PATTERN.test(value.trim());
}

export function resolveDisplayUsername(subscriber: SubscriberIdentityFields): string {
  if (subscriber.displayUsername?.trim()) return subscriber.displayUsername.trim();

  const portal = subscriber.portalUsername?.trim();
  if (portal) return portal;

  const username = subscriber.username?.trim();
  if (username && !isMacStyleUsername(username)) return username;

  return username || '−';
}

export function resolveNetworkUsername(subscriber: SubscriberIdentityFields): string | null {
  if (subscriber.networkUsername?.trim()) return subscriber.networkUsername.trim();

  const username = subscriber.username?.trim();
  if (!username || !isMacStyleUsername(username)) return null;

  const display = resolveDisplayUsername(subscriber);
  if (display === username) return null;

  return username;
}
